import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Service.vue'
import store from './store'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/product',
            name: 'product',
            component: () =>
                import ( /* webpackChunkName: "about" */ './views/Product.vue')
        },
        {
            path: '/service',
            name: 'service',
            component: () =>
                import ( /* webpackChunkName: "about" */ './views/Service.vue')
        },
        {
            path: '/operation',
            name: 'operation',
            component: () =>
                import ( /* webpackChunkName: "about" */ './views/Operation.vue')
        },
        {
            path: '/mine',
            name: 'mine',
            component: () =>
                import ( /* webpackChunkName: "about" */ './views/Mine.vue')
        },
        {
            path: '/data_bind',
            name: 'data_bind',
            component: () =>
                import ('./views/DataBind.vue'),
            meta: {
                requiresAuth: true // add meta field for authentication check
            }
        },
        {
            path: '/query_data_bind',
            name: 'query_data_bind',
            component: () =>
                import ('./views/QueryDataBind.vue'),
            meta: {
                requiresAuth: true // add meta field for authentication check
            }
        },
        {
            path: '/in_repository',
            name: 'in_repository',
            component: () =>
                import ('./views/InRepository.vue'),
            meta: {
                requiresAuth: true // add meta field for authentication check
            }
        },
        {
            path: '/out_repository',
            name: 'out_repository',
            component: () =>
                import ('./views/OutRepository.vue'),
            meta: {
                requiresAuth: true // add meta field for authentication check
            }
        },
        {
            path: '/back_repository',
            name: 'back_repository',
            component: () =>
                import ('./views/BackRepository.vue'),
            meta: {
                requiresAuth: true // add meta field for authentication check
            }
        },
        {
            path: '/ratail_repository',
            name: 'ratail_repository',
            component: () =>
                import ('./views/RatailOutRepository.vue'),
            meta: {
                requiresAuth: true // add meta field for authentication check
            }
        },
        {
            title: '扫码页面',
            name: 'scanCodePage',
            path: '/scanCodePage',
            component: () => import('./views/scanCodePage.vue')
        }
    ]
});

// Navigation guard
router.beforeEach((to, from, next) => {
    // Check if the route requires authentication
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // Assuming you have a Vuex store and the user information is stored there
        console.log(store.state, 'store.state')
        if (!store.state.user.username) {
            next('/'); // Assuming your login route is '/login'
        } else {
            next(); // Continue to the route
        }
    } else {
        // If the route does not require authentication, proceed normally
        next();
    }
});

export default router;